/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_PURCHASE_INVOICE_REPORT = `${url}/LOAD_PURCHASE_INVOICE_REPORT`;
export const LOAD_PURCHASE_INVOICE_REPORT_SUCCESS = `${url}/LOAD_PURCHASE_INVOICE_REPORT_SUCCESS`;
export const LOAD_PURCHASE_INVOICE_REPORT_ERROR = `${url}/LOAD_PURCHASE_INVOICE_REPORT_ERROR`;

export const LOAD_LEDGER_STATEMENT_REPORT = `${url}/LOAD_LEDGER_STATEMENT_REPORT`;
export const LOAD_LEDGER_STATEMENT_REPORT_SUCCESS = `${url}/LOAD_LEDGER_STATEMENT_REPORT_SUCCESS`;
export const LOAD_LEDGER_STATEMENT_REPORT_ERROR = `${url}/LOAD_LEDGER_STATEMENT_REPORT_ERROR`;

export const LOAD_PARTY_WISE_OUTSTANDING_REPORT = `${url}/LOAD_PARTY_WISE_OUTSTANDING_REPORT`;
export const LOAD_PARTY_WISE_OUTSTANDING_REPORT_SUCCESS = `${url}/LOAD_PARTY_WISE_OUTSTANDING_REPORT_SUCCESS`;
export const LOAD_PARTY_WISE_OUTSTANDING_REPORT_ERROR = `${url}/LOAD_PARTY_WISE_OUTSTANDING_REPORT_ERROR`;

export const LOAD_PURCHASE_INVOICE_BARCODE = `${url}/LOAD_PURCHASE_INVOICE_BARCODE`;
export const LOAD_PURCHASE_INVOICE_BARCODE_SUCCESS = `${url}/LOAD_PURCHASE_INVOICE_BARCODE_SUCCESS`;
export const LOAD_PURCHASE_INVOICE_BARCODE_ERROR = `${url}/LOAD_PURCHASE_INVOICE_BARCODE_ERROR`;

export const LOAD_REPORTS_DASHBOARD_TRANSACTION = `${url}/LOAD_REPORTS_DASHBOARD_TRANSACTION`;
export const LOAD_REPORTS_DASHBOARD_TRANSACTION_SUCCESS = `${url}/LOAD_REPORTS_DASHBOARD_TRANSACTION_SUCCESS`;
export const LOAD_REPORTS_DASHBOARD_TRANSACTION_ERROR = `${url}/LOAD_REPORTS_DASHBOARD_TRANSACTION_ERROR`;

export const LOAD_PURCHASE_REPORT_TOTAL = `${url}/LOAD_PURCHASE_REPORT_TOTAL`;
export const LOAD_PURCHASE_REPORT_TOTAL_SUCCESS = `${url}/LOAD_PURCHASE_REPORT_TOTAL_SUCCESS`;
export const LOAD_PURCHASE_REPORT_TOTAL_ERROR = `${url}/LOAD_PURCHASE_REPORT_TOTAL_ERROR`;

export const LOAD_TOTAL_REPORT_PAID = `${url}/LOAD_TOTAL_REPORT_PAID`;
export const LOAD_TOTAL_REPORT_PAID_SUCCESS = `${url}/LOAD_TOTAL_REPORT_PAID_SUCCESS`;
export const LOAD_TOTAL_REPORT_PAID_ERROR = `${url}/LOAD_TOTAL_REPORT_PAID_ERROR`;

export const LOAD_TOTAL_REPORT_UNPAID = `${url}/LOAD_TOTAL_REPORT_UNPAID`;
export const LOAD_TOTAL_REPORT_UNPAID_SUCCESS = `${url}/LOAD_TOTAL_REPORT_UNPAID_SUCCESS`;
export const LOAD_TOTAL_REPORT_UNPAID_ERROR = `${url}/LOAD_TOTAL_REPORT_UNPAID_ERROR`;

export const CREATE_PURCHASE_INVOICE = `${url}/CREATE_PURCHASE_INVOICE`;
export const CREATE_PURCHASE_INVOICE_SUCCESS = `${url}/CREATE_PURCHASE_INVOICE_SUCCESS`;
export const CREATE_PURCHASE_INVOICE_ERROR = `${url}/CREATE_PURCHASE_INVOICE_ERROR`;

//category
export const LOAD_PURCHASE_INVOICE_CATEGORY = `${url}/LOAD_PURCHASE_INVOICE_CATEGORY`;
export const LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS = `${url}/LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS`;
export const LOAD_PURCHASE_INVOICE_CATEGORY_ERROR = `${url}/LOAD_PURCHASE_INVOICE_CATEGORY_ERROR`;

export const CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY = `${url}/CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY`;
export const CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS = `${url}/CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS`;
export const CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR = `${url}/CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR`;

export const UPDATE_PURCHASE_INVOICE = `${url}/UPDATE_PURCHASE_INVOICE`;
export const UPDATE_PURCHASE_INVOICE_SUCCESS = `${url}/UPDATE_PURCHASE_INVOICE_SUCCESS`;
export const UPDATE_PURCHASE_INVOICE_ERROR = `${url}/UPDATE_PURCHASE_INVOICE_ERROR`;

export const DELETE_PURCHASE_INVOICE = `${url}/DELETE_PURCHASE_INVOICE`;
export const DELETE_PURCHASE_INVOICE_SUCCESS = `${url}/DELETE_PURCHASE_INVOICE_SUCCESS`;
export const DELETE_PURCHASE_INVOICE_ERROR = `${url}/DELETE_PURCHASE_INVOICE_ERROR`;

export const LOAD_REPORTS_META_DATA = `${url}/LOAD_REPORTS_META_DATA`;
export const LOAD_REPORTS_META_DATA_SUCCESS = `${url}/LOAD_REPORTS_META_DATA_SUCCESS`;
export const LOAD_REPORTS_META_DATA_ERROR = `${url}/LOAD_REPORTS_META_DATA_ERROR`;

export const LOAD_BILL_STATUS_META_DATA = `${url}/LOAD_BILL_STATUS_META_DATA`;
export const LOAD_BILL_STATUS_META_DATA_SUCCESS = `${url}/LOAD_BILL_STATUS_META_DATA_SUCCESS`;
export const LOAD_BILL_STATUS_META_DATA_ERROR = `${url}/LOAD_BILL_STATUS_META_DATA_ERROR`;

export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_PARTIES_TRANSACTION = `${url}/LOAD_PARTIES_TRANSACTION`;
export const LOAD_PARTIES_TRANSACTION_SUCCESS = `${url}/LOAD_PARTIES_TRANSACTION_SUCCESS`;
export const LOAD_PARTIES_TRANSACTION_ERROR = `${url}/LOAD_PARTIES_TRANSACTION_ERROR`;

// address update
export const LOAD_PARTY_VENDOR_ADDRESS = `${url}/LOAD_PARTY_VENDOR_ADDRESS`;
export const LOAD_PARTY_VENDOR_ADDRESS_SUCCESS = `${url}/LOAD_PARTY_VENDOR_ADDRESS_SUCCESS`;
export const LOAD_PARTY_VENDOR_ADDRESS_ERROR = `${url}/LOAD_PARTY_VENDOR_ADDRESS_ERROR`;

export const CREATE_PARTY_VENDOR_ADDRESS = `${url}/CREATE_PARTY_VENDOR_ADDRESS`;
export const CREATE_PARTY_VENDOR_ADDRESS_SUCCESS = `${url}/CREATE_PARTY_VENDOR_ADDRESS_SUCCESS`;
export const CREATE_PARTY_VENDOR_ADDRESS_ERROR = `${url}/CREATE_PARTY_VENDOR_ADDRESS_ERROR`;

// stock report
export const LOAD_STOCK_REPORT_DETAILS = `${url}/LOAD_STOCK_REPORT_DETAILS`;
export const LOAD_STOCK_REPORT_DETAILS_SUCCESS = `${url}/LOAD_STOCK_REPORT_DETAILS_SUCCESS`;
export const LOAD_STOCK_REPORT_DETAILS_ERROR = `${url}/LOAD_STOCK_REPORT_DETAILS_ERROR`;
export const LOAD_STOCK_SUMMARY_REPORT_DETAILS = `${url}/LOAD_STOCK_SUMMARY_REPORT_DETAILS`;
export const LOAD_STOCK_SUMMARY_REPORT_DETAILS_SUCCESS = `${url}/LOAD_STOCK_SUMMARY_REPORT_DETAILS_SUCCESS`;
export const LOAD_STOCK_SUMMARY_REPORT_DETAILS_ERROR = `${url}/LOAD_STOCK_SUMMARY_REPORT_DETAILS_ERROR`;

//profit report
export const LOAD_PROFIT_REPORT_LIST = `${url}/LOAD_PROFIT_REPORT_LIST`;
export const LOAD_PROFIT_REPORT_LIST_SUCCESS = `${url}/LOAD_PROFIT_REPORT_LIST_SUCCESS`;
export const LOAD_PROFIT_REPORT_LIST_ERROR = `${url}/LOAD_PROFIT_REPORT_LIST_ERROR`;

export const LOAD_SALES_ITEMS_QUANTITY_REPORT = `${url}/LOAD_SALES_ITEMS_QUANTITY_REPORT`;
export const LOAD_SALES_ITEMS_QUANTITY_REPORT_SUCCESS = `${url}/LOAD_SALES_ITEMS_QUANTITY_REPORT_SUCCESS`;
export const LOAD_SALES_ITEMS_QUANTITY_REPORT_ERROR = `${url}/LOAD_SALES_ITEMS_QUANTITY_REPORT_ERROR`;

//sales report
export const LOAD_SALES_FILTER_REPORT = `${url}/LOAD_SALES_FILTER_REPORT`;
export const LOAD_SALES_FILTER_REPORT_SUCCESS = `${url}/LOAD_SALES_FILTER_REPORT_SUCCESS`;
export const LOAD_SALES_FILTER_REPORT_ERROR = `${url}/LOAD_SALES_FILTER_REPORT_ERROR`;

//sales summary report
export const LOAD_SALES_SUMMARY_REPORT = `${url}/LOAD_SALES_SUMMARY_REPORT`;
export const LOAD_SALES_SUMMARY_REPORT_SUCCESS = `${url}/LOAD_SALES_SUMMARY_REPORT_SUCCESS`;
export const LOAD_SALES_SUMMARY_REPORT_ERROR = `${url}/LOAD_SALES_SUMMARY_REPORT_ERROR`;

//purchase summary report
export const LOAD_PURCHASE_SUMMARY_REPORT = `${url}/LOAD_PURCHASE_SUMMARY_REPORT`;
export const LOAD_PURCHASE_SUMMARY_REPORT_SUCCESS = `${url}/LOAD_PURCHASE_SUMMARY_REPORT_SUCCESS`;
export const LOAD_PURCHASE_SUMMARY_REPORT_ERROR = `${url}/LOAD_PURCHASE_SUMMARY_REPORT_ERROR`;

export const LOAD_SALES_RETURN_REPORT = `${url}/LOAD_SALES_RETURN_REPORT`;
export const LOAD_SALES_RETURN_REPORT_SUCCESS = `${url}/LOAD_SALES_RETURN_REPORT_SUCCESS`;
export const LOAD_SALES_RETURN_REPORT_ERROR = `${url}/LOAD_SALES_RETURN_REPORT_ERROR`;
export const LOAD_SALES_RETURN_ITEMS_REPORT = `${url}/LOAD_SALES_RETURN_ITEMS_REPORT`;
export const LOAD_SALES_RETURN_ITEMS_REPORT_SUCCESS = `${url}/LOAD_SALES_RETURN_ITEMS_REPORT_SUCCESS`;
export const LOAD_SALES_RETURN_ITEMS_REPORT_ERROR = `${url}/LOAD_SALES_RETURN_ITEMS_REPORT_ERROR`;

export const LOAD_ITEMS_QUANTITY_REPORT = `${url}/LOAD_ITEMS_QUANTITY_REPORT`;
export const LOAD_ITEMS_QUANTITY_REPORT_SUCCESS = `${url}/LOAD_ITEMS_QUANTITY_REPORT_SUCCESS`;
export const LOAD_ITEMS_QUANTITY_REPORT_ERROR = `${url}/LOAD_ITEMS_QUANTITY_REPORT_ERROR`;
export const LOAD_TICKETING_DETAILS = `${url}/LOAD_TICKETING_DETAILS`;
export const LOAD_TICKETING_DETAILS_SUCCESS = `${url}/LOAD_TICKETING_DETAILS_SUCCESS`;
export const LOAD_TICKETING_DETAILS_ERROR = `${url}/LOAD_TICKETING_DETAILS_ERROR`;
export const LOAD_TICKET_REPLY_LIST = `${url}/LOAD_TICKET_REPLY_LIST`;
export const LOAD_TICKET_REPLY_LIST_SUCCESS = `${url}/LOAD_TICKET_REPLY_LIST_SUCCESS`;
export const LOAD_TICKET_REPLY_LIST_ERROR = `${url}/LOAD_TICKET_REPLY_LIST_ERROR`;

const constants = {
  LOAD_PURCHASE_INVOICE_REPORT,
  LOAD_PURCHASE_INVOICE_REPORT_SUCCESS,
  LOAD_PURCHASE_INVOICE_REPORT_ERROR,

  LOAD_LEDGER_STATEMENT_REPORT,
  LOAD_LEDGER_STATEMENT_REPORT_SUCCESS,
  LOAD_LEDGER_STATEMENT_REPORT_ERROR,
  LOAD_TICKETING_DETAILS,
  LOAD_TICKETING_DETAILS_SUCCESS,
  LOAD_TICKETING_DETAILS_ERROR,
  LOAD_TICKET_REPLY_LIST,
  LOAD_TICKET_REPLY_LIST_SUCCESS,
  LOAD_TICKET_REPLY_LIST_ERROR,
  LOAD_PARTY_WISE_OUTSTANDING_REPORT,
  LOAD_PARTY_WISE_OUTSTANDING_REPORT_SUCCESS,
  LOAD_PARTY_WISE_OUTSTANDING_REPORT_ERROR,

  LOAD_PURCHASE_INVOICE_BARCODE,
  LOAD_PURCHASE_INVOICE_BARCODE_SUCCESS,
  LOAD_PURCHASE_INVOICE_BARCODE_ERROR,
  LOAD_PROFIT_REPORT_LIST,
  LOAD_PROFIT_REPORT_LIST_SUCCESS,
  LOAD_PROFIT_REPORT_LIST_ERROR,

  LOAD_REPORTS_DASHBOARD_TRANSACTION,
  LOAD_REPORTS_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_REPORTS_DASHBOARD_TRANSACTION_ERROR,
  LOAD_PURCHASE_REPORT_TOTAL,
  LOAD_PURCHASE_REPORT_TOTAL_SUCCESS,
  LOAD_PURCHASE_REPORT_TOTAL_ERROR,

  LOAD_TOTAL_REPORT_PAID,
  LOAD_TOTAL_REPORT_PAID_SUCCESS,
  LOAD_TOTAL_REPORT_PAID_ERROR,

  LOAD_TOTAL_REPORT_UNPAID,
  LOAD_TOTAL_REPORT_UNPAID_SUCCESS,
  LOAD_TOTAL_REPORT_UNPAID_ERROR,

  LOAD_PARTY_VENDOR_ADDRESS,
  LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PARTY_VENDOR_ADDRESS_ERROR,

  CREATE_PARTY_VENDOR_ADDRESS,
  CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PARTY_VENDOR_ADDRESS_ERROR,

  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,

  LOAD_PURCHASE_INVOICE_CATEGORY,
  LOAD_PURCHASE_INVOICE_CATEGORY_SUCCESS,
  LOAD_PURCHASE_INVOICE_CATEGORY_ERROR,

  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PURCHASE_INVOICE_PARTIES_CATEGORY_ERROR,

  CREATE_PURCHASE_INVOICE,
  CREATE_PURCHASE_INVOICE_SUCCESS,
  CREATE_PURCHASE_INVOICE_ERROR,

  UPDATE_PURCHASE_INVOICE,
  UPDATE_PURCHASE_INVOICE_SUCCESS,
  UPDATE_PURCHASE_INVOICE_ERROR,

  DELETE_PURCHASE_INVOICE,
  DELETE_PURCHASE_INVOICE_SUCCESS,
  DELETE_PURCHASE_INVOICE_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_REPORTS_META_DATA,
  LOAD_REPORTS_META_DATA_SUCCESS,
  LOAD_REPORTS_META_DATA_ERROR,

  //stock report
  LOAD_STOCK_REPORT_DETAILS,
  LOAD_STOCK_REPORT_DETAILS_SUCCESS,
  LOAD_STOCK_REPORT_DETAILS_ERROR,
  LOAD_ITEMS_QUANTITY_REPORT,
  LOAD_ITEMS_QUANTITY_REPORT_SUCCESS,
  LOAD_ITEMS_QUANTITY_REPORT_ERROR,
  LOAD_SALES_ITEMS_QUANTITY_REPORT,
  LOAD_SALES_ITEMS_QUANTITY_REPORT_SUCCESS,
  LOAD_SALES_ITEMS_QUANTITY_REPORT_ERROR,
  LOAD_SALES_FILTER_REPORT,
  LOAD_SALES_FILTER_REPORT_SUCCESS,
  LOAD_SALES_FILTER_REPORT_ERROR,
  LOAD_SALES_RETURN_REPORT,
  LOAD_SALES_RETURN_REPORT_SUCCESS,
  LOAD_SALES_RETURN_REPORT_ERROR,
  LOAD_SALES_RETURN_ITEMS_REPORT,
  LOAD_SALES_RETURN_ITEMS_REPORT_SUCCESS,
  LOAD_SALES_RETURN_ITEMS_REPORT_ERROR,

  LOAD_STOCK_SUMMARY_REPORT_DETAILS,
  LOAD_STOCK_SUMMARY_REPORT_DETAILS_SUCCESS,
  LOAD_STOCK_SUMMARY_REPORT_DETAILS_ERROR,

  //sales report
  LOAD_SALES_SUMMARY_REPORT,
  LOAD_SALES_SUMMARY_REPORT_SUCCESS,
  LOAD_SALES_SUMMARY_REPORT_ERROR,
  
  LOAD_PURCHASE_SUMMARY_REPORT,
  LOAD_PURCHASE_SUMMARY_REPORT_SUCCESS,
  LOAD_PURCHASE_SUMMARY_REPORT_ERROR,
  LOAD_BILL_STATUS_META_DATA,
  LOAD_BILL_STATUS_META_DATA_SUCCESS,
  LOAD_BILL_STATUS_META_DATA_ERROR,
};

export default constants;
